import { store } from "../store/configureStore";

import { setFormData } from "../utils/SettingsRetriever";

export const setForm = (form) => {
    setFormData(form);
    store.dispatch({ type: "SET_FORM_VALUE", value: form });
}